import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./index.vue?vue&type=style&index=1&id=6eb7cd24&lang=css"

const __exports__ = script;

export default __exports__